import { render } from "./TopAnime.vue?vue&type=template&id=3b995f77"
import script from "./TopAnime.vue?vue&type=script&lang=js"
export * from "./TopAnime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__